<script lang="ts">
  /*                                                                              */
  /*                                                                                                                      */

  import BoxSizingBorderBox from "./BoxSizingBorderBox.svelte";
  import DisplayBlockStyles from "./DisplayBlockStyles.svelte";
  import DisplayFlexStyles from "./DisplayFlexStyles.svelte";
  import DisplayInlineBlockStyles from "./DisplayInlineBlockStyles.svelte";
  import FitContentStyles from "./FitContentStyles.svelte";
  import InlineFillParentStyles from "./InlineFillParentStyles.svelte";

  let {
    contentBox = false,
    display = undefined,
    inline = false,
    widthBehavior = "fill",
  }: {
    /**
 *
 */
    contentBox?: boolean;
    /**
 *
 */
    display?: "block" | "inline-block" | "flex";
    /**
 *
 */
    inline?: boolean;
    /**
 *
 *
 *
 */
    widthBehavior?: "fill" | "fit";
  } = $props();
</script>

<!--prevent whitespace between elements for inline layout-->
<!-- prettier-ignore-start
-->{#if !contentBox}<!--
  --><BoxSizingBorderBox /><!--
-->{/if}<!--
-->{#if display === "block"}<!--
  --><DisplayBlockStyles /><!--
-->{:else if display === "inline-block"}<!--
  --><DisplayInlineBlockStyles /><!--
-->{:else if display === "flex"}<!--
  --><DisplayFlexStyles /><!--
-->{/if}<!--
-->{#if widthBehavior === "fit"}<!--
  --><FitContentStyles /><!--
-->{:else if widthBehavior === "fill" && inline}<!--
  --><InlineFillParentStyles /><!--
-->{/if}
<!-- prettier-ignore-end -->

<style lang="scss">
  @use "@otto-ec/otto-components-utils/scss/mixins";
  :global {
    * {
      letter-spacing: unset;
      line-height: unset;
      word-spacing: unset;
    }

    :host {
      @include mixins.no-tap-highlight();
    }
  }
</style>
